import Form from "Clutch/Atoms/Form";
import { GetSelectOptions, Calculate } from "./logic";
import { useState } from "react";
import Typography from "Clutch/Atoms/Typography";
import Button from "Clutch/Molecules/Button";
import ContextualError from "../common/contextualError";
import FormGroup from "../common/formGroup";


const TestCalculator = () => {

    const dropDownValues = GetSelectOptions();

    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(dropDownValues[0]);
    const [result, setResult] = useState({
        isValid: false,
        errors: []
    });

    const CalculateInternal = (e) => {
        e.preventDefault()
        const r = Calculate(num1, num2);
        setResult(r)
    }

    const error1 = result.errors.find(x => x.id == 'num1');
    const error2 = result.errors.find(x => x.id == 'num2');
    return <Form onSubmit={CalculateInternal}>
        <FormGroup>
            <Form.Textbox
                fill
                id={'num1'}
                label={`First Number`}
                intent={error1 ? 'negative' : null}
                value={num1}
                onChange={(e) => { setNum1(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={error1} />
        </FormGroup>

        <FormGroup>
            <Form.Select
                id={'num2'}
                label={`Second Number`}
                intent={error2 ? 'negative' : null}
                options={dropDownValues}
                onChange={(e) => { setNum2(e.target.value) }}
                value={num2} />
            <ContextualError error={error2} />
        </FormGroup>

        <FormGroup>
            <Button intent={'action'} size={'small'} event={{}} text={"Calculate"}></Button>
        </FormGroup>

        <FormGroup>
            {result.isValid ? <Typography size={1.25}>{result.label}<Typography as={'span'} size={1.25} font={'bold'}>{result.result}</Typography> </Typography> : false}
        </FormGroup>


    </Form>
}

export default TestCalculator